import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { showError } from '../services/alert';
import { geolocationErrorMessage, getCurrentDeviceLocation } from '../utils/geolocation';
import './LocationPicker.css';

const DEFAULT_CENTER = [-14.235, -51.9253];

export default function LocationPicker({ latitude, longitude, onChange, disabled, locationLabel = 'Usar minha localização' }) {
  const mapElement = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const [locating, setLocating] = useState(false);

  useEffect(() => {
    if (!mapElement.current || mapRef.current) return undefined;
    const hasPoint = Number.isFinite(Number(latitude)) && Number.isFinite(Number(longitude)) && latitude !== '' && longitude !== '';
    const map = L.map(mapElement.current, { zoomControl: true }).setView(hasPoint ? [Number(latitude), Number(longitude)] : DEFAULT_CENTER, hasPoint ? 13 : 4);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap', maxZoom: 19,
    }).addTo(map);
    map.on('click', ({ latlng }) => {
      if (!disabled) onChange(Number(latlng.lat.toFixed(6)), Number(latlng.lng.toFixed(6)));
    });
    mapRef.current = map;
    setTimeout(() => map.invalidateSize(), 0);
    return () => { map.remove(); mapRef.current = null; markerRef.current = null; };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    const hasPoint = latitude !== '' && longitude !== '' && Number.isFinite(Number(latitude)) && Number.isFinite(Number(longitude));
    if (!map || !hasPoint) return;
    const point = [Number(latitude), Number(longitude)];
    if (!markerRef.current) markerRef.current = L.marker(point).addTo(map);
    else markerRef.current.setLatLng(point);
    map.setView(point, Math.max(map.getZoom(), 12), { animate: true });
  }, [latitude, longitude]);

  const useCurrentLocation = async () => {
    setLocating(true);
    try {
      const location = await getCurrentDeviceLocation();
      onChange(location.latitude, location.longitude);
    } catch (error) {
      showError(error?.code ? geolocationErrorMessage(error) : error?.message || geolocationErrorMessage(error));
    } finally {
      setLocating(false);
    }
  };

  return (
    <div className="location-picker">
      <div className={`location-map ${disabled ? 'disabled' : ''}`} ref={mapElement} aria-label="Mapa para selecionar a localização" />
      <button
        type="button"
        className="btn btn-light btn-sm location-current-button"
        onClick={useCurrentLocation}
        disabled={disabled || locating}
      >
        <i className={`bi ${locating ? 'bi-arrow-repeat location-spin' : 'bi-crosshair'}`} />
        <span>{locating ? 'Obtendo localização...' : locationLabel}</span>
      </button>
    </div>
  );
}
